module.exports = __webpack_public_path__ + "static/img/wtsLogo.745208bf.png";